























import { Component, Vue } from "vue-property-decorator";
import {i18n} from '@/plugins/i18n';

@Component({
  name: "Maintenance",
  components: {},
})
export default class Maintenance extends Vue {
  //i18n.t('globals.maintenanceMode') as string;
  description: string = "El sistema se encuentra en mantenimiento, esto puede tardar unos minutos";
  
  mounted() {
    if(localStorage.getItem('maintenance')) {
      const alert = localStorage.getItem('maintenance');
      this.description = JSON.parse(alert as string).text;
    }
  };
}
